import * as React from "react"
import { cn } from "src/lib/utils"

const TableContainer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(className)}
    style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 16, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}
    {...props}
  />
))
TableContainer.displayName = "TableContainer"

const Table = React.forwardRef(({ className, ...props }, ref) => (
  <div className="relative w-full overflow-auto">
    <table ref={ref} className={cn("w-full border-collapse", className)} {...props} />
  </div>
))
Table.displayName = "Table"

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead ref={ref} className={cn(className)} style={{ background: 'var(--yool-page)', borderBottom: '1px solid #E0E0E0' }} {...props} />
))
TableHeader.displayName = "TableHeader"

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody ref={ref} className={className} {...props} />
))
TableBody.displayName = "TableBody"

const TableFooter = React.forwardRef(({ className, ...props }, ref) => (
  <tfoot
    ref={ref}
    className={cn(className)}
    style={{ display: 'flex', alignItems: 'center', padding: '11px 18px', borderTop: '1px solid #E0E0E0', background: 'var(--yool-page)', fontSize: 12, color: 'var(--yool-muted)' }}
    {...props}
  />
))
TableFooter.displayName = "TableFooter"

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr ref={ref} className={cn("transition-colors hover:bg-[#F7F8F9]", className)} {...props} />
))
TableRow.displayName = "TableRow"

const TableHead = React.forwardRef(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={cn("[&:has([role=checkbox])]:pr-0", className)}
    style={{ padding: '10px 16px', fontSize: 10.5, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.08em', color: '#9499A0', whiteSpace: 'nowrap', textAlign: 'left' }}
    {...props}
  />
))
TableHead.displayName = "TableHead"

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={cn("[&:has([role=checkbox])]:pr-0", className)}
    style={{ padding: '13px 16px', color: 'var(--yool-black)', borderBottom: '1px solid #E8E8E8', fontSize: 13 }}
    {...props}
  />
))
TableCell.displayName = "TableCell"

const TableCaption = React.forwardRef(({ className, ...props }, ref) => (
  <caption ref={ref} className={cn("mt-4 text-sm text-muted-foreground", className)} {...props} />
))
TableCaption.displayName = "TableCaption"

export {
  Table,
  TableContainer,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
